import LogRocket from 'logrocket';

export default LogRocket;
